module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/august-0f052c13748d6f3912c3caaea6bf4eb1.png";